module.exports = __webpack_public_path__ + "img/fuss_free.png";